export class Tab{
  constructor(
    public nombre:string ,
    public active:boolean,
    public posmenu:number,
    public possubmenu:number,
    public ruta:string,
    public permisos:any[]
  ){}
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/model/Tab.ts